import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import IncreaseDecreaseArrows from "../../components/increase-decrease-arrows/index.js";

const ComplianceCard = ({ data, colours, FONT }) => {
    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: { xs: '100%', sm: '50%' }, borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <CardHeaderTitle
                title="Compliance"
                tooltip="Company Introduction and Recording Disclosures are key components of the Vocalysd Score, given an agent's minimum disclosure requirements. These metrics are determined by the detection of trackers in each conversation. A higher % indicates better adherence to standards."
                viewDetailTitle="View Details"
                viewDetailAction={() => console.log('show some data')}
            />

            <Grid
                container
                spacing={0}
                direction="row"
                gap={3}
                marginTop={2}
            >
                <Grid item xs>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>Intro Company</div>
                    <Typography variant="h5" component="div" fontWeight={600}>
                        {data.introcompany_detect}%
                    </Typography>
                    <IncreaseDecreaseArrows increase={true} percentage="4%" />
                </Grid>
                <Grid item xs>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>Recording Disclosed</div>
                    <Typography variant="h5" component="div" fontWeight={600}>
                        {data.recording_disclosure_detect}%
                    </Typography>
                    <IncreaseDecreaseArrows increase={false} percentage="12%" />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ComplianceCard;